import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export function UpgradeBadge({ plan = "Pro", message, testId }) {
    return (
        <Link
            to="/app/billing"
            data-testid={testId || "upgrade-badge"}
            className="inline-flex items-center gap-2 rounded-full bg-coral/10 text-coral-dark border border-coral/20 px-3 py-1.5 text-xs font-medium hover:bg-coral/15 transition-colors"
        >
            <Sparkles className="h-3.5 w-3.5" />
            <span>{message || `Upgrade to ${plan}`}</span>
        </Link>
    );
}

export default UpgradeBadge;
